<script setup>

import {onMounted, ref} from 'vue';
import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/stores/user';
import {useFetch} from "@/composables/useFetch.js";
import {uri} from "@/constants/config.js";

const { t } = useI18n();
const url = new URL(window.location.href);
const selfUrl = new URL(window.location.href);
selfUrl.pathname = '/auth/callback';
selfUrl.search = '';
url.searchParams.set('callbackURL', selfUrl.toString());
const loading = ref(true);
const hasError = ref(false);
const isSuccess = ref(false);
const message = ref('');
const user = useUserStore()
const {t: $t} = useI18n()

async function tryLogin() {
  try {
    // Await the result of the API call
    const {data, error} = await useFetch(uri.api.auth.redirect.google, {
      method: 'GET',
      params: url.searchParams,
    });

    if (error) {
      message.value = error.message || $t('title.auth.google.resultTitle'); // Handle error message gracefully
      hasError.value = true;
    } else {
      user.setUser(data)
      message.value = $t('title.auth.google.success');
      isSuccess.value = true;
    }
  } catch (err) {
    console.error(err);
    message.value = err.message || $t('title.auth.google.resultTitle'); // Ensure fallback for unexpected errors
    hasError.value = true;
  } finally {
    loading.value = false;
  }
}


onMounted(() => {
  tryLogin()
})


</script>

<template>
  <div class="min-h-screen flex flex-col text-white">
    <!-- Header -->
    <div class="flex justify-between items-center px-4 py-4">
      <div>
        <button class=" hover:text-blue-500">
          <!-- Replace with your theme toggle button -->

        </button>
      </div>
      <router-link
          class="hover:text-blue-500 flex items-center gap-2"
          to="/"
      >
        <span>{{ $t('title.auth.returnHome') }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </router-link>
    </div>

    <!-- Main Content -->
    <div class="flex-grow flex items-center justify-center">
      <div class="text-center max-w-md mx-auto">
        <!-- Icon State -->
        <div class="my-8">
          <div v-if="loading" class="animate-spin h-16 w-16 border-4 border-blue-500 border-t-transparent rounded-full mx-auto"></div>
          <div v-else-if="isSuccess" class="text-green-500 text-4xl">✔</div>
          <div v-else-if="hasError" class="text-red-500 text-4xl">✖</div>
          <div v-else class="text-blue-500 text-4xl">🔒</div>
        </div>

        <!-- Title -->
        <h2 class="text-3xl font-semibold mb-2">
          <span v-if="loading">{{ $t('title.auth.google.loadingTitle') }}</span>
          <span v-else>{{ $t('title.auth.google.resultTitle') }}</span>
        </h2>

        <!-- Message -->
        <p class="mb-6">{{ message }}</p>

        <!-- Button -->
        <router-link
            v-if="isSuccess"
            to="/"
            class="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg"
        >
          {{ $t('title.go-to-dashboard') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Add any custom styles here if necessary */
</style>
